// Formats a duration in seconds as "01h 05min 09s". Hours do not roll over at a day, so a
// meal left in a locker overnight reads as "26h 13min 04s" rather than "02h 13min 04s".
export const formatDurationHms = (
  seconds: number | null | undefined,
  placeholder = '-'
): string => {
  if (seconds == null || seconds < 0) return placeholder

  const whole = Math.floor(seconds)
  const pad = (value: number) => String(value).padStart(2, '0')
  const hours = Math.floor(whole / 3600)
  const minutes = Math.floor((whole % 3600) / 60)

  return `${pad(hours)}h ${pad(minutes)}min ${pad(whole % 60)}s`
}
